import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import {
    EurekaAllHistoryApi,
    type EurekaAllHistoryApi as EurekaAllHistoryApiType,
} from '../../apis/eureka-all-history-api';
import type { EurekaAllHistoryService } from '../eureka-all-history-service';

/** 通过 Eureka 全部历史 API 判断当前账号是否为老用户。 */
@injectable()
export class EurekaAllHistoryServiceImpl implements EurekaAllHistoryService {
    constructor(
        /** 提供当前账号的全部历史任务总数。 */
        @inject(EurekaAllHistoryApi)
        private readonly _eurekaAllHistoryApi: EurekaAllHistoryApiType,
    ) {}

    /** 获取全部历史任务总数。 */
    async getHistoryTotal(): Promise<number> {
        const result = await this._eurekaAllHistoryApi.getAllHistory();
        return result.total;
    }

    /** 根据全部历史任务总数判断是否存在历史。 */
    async hasHistory(): Promise<boolean> {
        return await this.getHistoryTotal() > 0;
    }
}
